module.exports = __webpack_public_path__ + "static/img/xray_3.6df86892.jpg";